import { useEffect, useRef } from 'react';
import { useShellStore } from '@renderer/app/state/shell-store';

export type EditorSaveHandler = (() => void | Promise<void>) | null;

export function useRegisterEditorSaveHandler(handler: EditorSaveHandler): void {
  const handlerRef = useRef<EditorSaveHandler>(handler);
  handlerRef.current = handler;

  const setEditorSaveHandler = useShellStore((state) => state.setEditorSaveHandler);

  useEffect(() => {
    const wrapped = () => handlerRef.current?.();
    setEditorSaveHandler(wrapped);
    return () => setEditorSaveHandler(null);
  }, [setEditorSaveHandler]);
}

